// SiteUp — Modo Foco: hub de entrada (Parte 3).
import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions';
import HubView from './HubView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/hub'),
    name: 'focus_hub',
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
    component: HubView,
  },
];
